module.exports = __webpack_public_path__ + "html/vehicle-editor.component.html";